import React from 'react';
import './Banner.scss';
import {Link} from 'react-router-dom';
import icon from '../../assets/banner/icons/Calling.png';
import bannerImg from '../../assets/banner/1.png';
import doctorImg from '../../assets/banner/doctor.png';
import bannerPattern from '../../assets/banner/pattern_02.png';
import shapeOne from '../../assets/banner/vector_01.png';
import shapeTwo from '../../assets/banner/vector_02.png';
import shapeThree from '../../assets/banner/vector_03.png';
import shapeFour from '../../assets/banner/pattern.png';

const Banner = () => {

    return (
        <section className='section-bg section-common banner-section'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text" data-aos="fade-up" data-aos-duration="2000">
                                    <h1>Entrust your smile to professionals</h1>
                                    <p>Smile confidently and feel amazing about your oral health with our expert care.</p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <Link to="/contact">Book an appointment</Link>
                                        </div>

                                        <div className="banner-call">
                                            <div className='icon'>
                                                <img src={icon} alt="icon" />
                                            </div>
                                            <div className='call-text'>
                                                <p>Dental 24H Emergency</p>
                                                <h6>8904674189</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="banner-img-area" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    <div className="banner-img">
                                        <img src={bannerImg} alt="banner model" />
                                    </div>
                                    <div className='info-box justify-space-between'>
  {/* Left Doctor */}
  <div className="info-item">
    <div className="info-img">
      <img src="https://imagesx.practo.com/providers/dr-bhagat-s-tanwar-dentist-faridabad-3b2d23ef-8e62-494c-a50f-7cdebfe4917a.jpg?i_type=t_70x70-2x-webp" alt="doctor" />
    </div>
    <div className='info-text'>
      <p>Dr. Bhagat Tanwar</p>
    </div>
  </div>

  {/* Right Doctor */}
  <div className="info-item">
    <div className="info-img">
      <img src="https://lh3.googleusercontent.com/p/AF1QipOdj71bwx2OvgXcvk5LsU4X2dSswh3pIzAe44FA=s1360-w1360-h1020-rw" alt="Poorna_Tanwar" />
    </div>
    <div className='info-text'>
      <p>Dr. Poorna Tanwar</p>
    </div>
  </div>
</div>
 
                                    



                                    {/* Vector Shapes */}
                                    <div className="shapes">
                                        <img src={shapeOne} alt="shape" />
                                        <img src={shapeTwo} alt="shape" />
                                        <img src={shapeThree} alt="shape" />
                                        <img src={shapeFour} alt="shape" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner Pattern Vector*/}
            <img className='banner-pattern' src={bannerPattern} alt="banner pattern" />
        </section>
    );
};

export default Banner;